import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { LoginService } from '../../core/services/login.service';
import { APP_CONSTANTS_TOKEN, AppConstants } from '../../core/constants';

declare let require: any;

@Component({
  selector: 'ng-logout',
  template: require('./ng-logout.component.html').default,
  styles: [require('!!raw-loader!sass-loader!./ng-logout.component.scss').default],
  standalone: false,
})
export class NgLogoutComponent implements OnInit {
  message: string;
  showMessage: boolean = false;
  company: string;

  constructor(
    @Inject(Router) private router: Router,
    @Inject(AuthService) private authService: AuthService,
    @Inject(LoginService) private loginService: LoginService,
    @Inject(APP_CONSTANTS_TOKEN) private constants: AppConstants
  ) {
    this.company = this.constants.company;
    this.message = this.constants.byeMessage;
  }

  ngOnInit(): void {
    // If already logged out, redirect to login immediately
    if (!this.loginService.getLoginState().isLoggedIn) {
      console.log('Already logged out');
      this.redirectToLogin();
      return;
    } else {
      console.log('Logged in');
      this.showMessage = true; // Show message only when logging out
      // Perform logout
      this.performLogout();
    }
  }

  private performLogout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.loginService.IsLoggedOut();
        if (this.company === 'kits') {
          setTimeout(() => {
            this.redirectToLogin();
          }, 4000);
        } else {
          this.redirectToLogin();
        }
      },
      error: () => {
        this.loginService.IsLoggedOut();
        this.redirectToLogin();
      },
    });
  }

  private redirectToLogin(): void {
    const loginPath = this.company === 'kits' ? '/login' : '/loginn';
    window.location.href = loginPath; // Use window.location for full redirect similar to legacy
  }
}
